import {
    BrowserRouter as OriginalRouter,
    Routes as OriginalRoutes,
    Route as OriginalRoute,
    useNavigate as OriginalUseNavigate,
    useLocation as OriginalUseLocation,
	useParams as OriginalUseParams,
	NavLink as OriginalNavLink,
	useSearchParams,
	Navigate as OriginalNavigate,
	matchRoutes as originalMatchRoutes,
} from 'react-router-dom';

// Exporting the originals with a new name
export const Router = OriginalRouter;
export const Route = OriginalRoute;
export const SwitchRoutes = OriginalRoutes;
export const useParams = OriginalUseParams;
export const Navigate = OriginalNavigate;

export function useNavigate() {
	const navigate = OriginalUseNavigate();

	function goTo(path, state) {
		if (state) {
			navigate(path, {state});
		} else {
			navigate(path);
		}
	}

	function replace(path, state) {
		navigate(path, { replace: true, state });
	}

	return {
		goTo,
		replace,
		navigate
	};
}

export function useLocation() {
	const location = OriginalUseLocation();
	return {
		currentPath: location.pathname,
		currentState: location.state,
	};
}

export const NavLink = ({to, className, children}) => {
	return (
		<OriginalNavLink to={to} className={className}>
			{children}
		</OriginalNavLink>
	)
}

export function useQuery() {
	const [searchParams] = useSearchParams();

	return searchParams;
}

export function matchRoutes(routes, pathname) {
	return originalMatchRoutes(routes, pathname);
}
